/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_04_Detail_Amateur_0_HeadingInputs */

const en_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The finish you have been resisting`)
};

const es_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El finish que has estado resistiendo`)
};

const de_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Ende, gegen das Sie sich gewehrt haben`)
};

const zh_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你一直在抗拒的收杆`)
};

const ar_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإنهاء الذي كنت تقاومه`)
};

const fr_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le finish auquel vous résistiez`)
};

const vi_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish bạn đã chống lại`)
};

const sw_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umaliziaji ambao umekuwa ukiupinga`)
};

const th_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ท่าจบที่คุณต่อต้านมาตลอด`)
};

const bs_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish kojem si se opirao`)
};

const ja_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたが抑え込んできたフィニッシュ`)
};

const ko_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그동안 거부해 온 피니시`)
};

const pt_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O finish ao qual você vem resistindo`)
};

const it_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il finish a cui hai resistito`)
};

const sv_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finishen du har kämpat emot`)
};

const nl_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De finish waartegen je je hebt verzet`)
};

const da_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den finish, du har kæmpet imod`)
};

const nb_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finishen du har kjempet mot`)
};

const fi_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loppuasento, jota olet vastustanut`)
};

const pl_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wykończenie, przed którym się bronisz`)
};

const ru_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Финиш, которому вы сопротивлялись`)
};

const tr_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direndiğiniz bitiriş`)
};

const hi_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह फ़िनिश जिसका आप विरोध करते आए हैं`)
};

const id_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish yang selama ini Anda lawan`)
};

const ms_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penamat yang selama ini anda tahan`)
};

const cs_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakončení, kterému se bráníte`)
};

const el_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το τελείωμα στο οποίο αντιστεκόσασταν`)
};

const he_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תנוחת הסיום שהתנגדת לה`)
};

const af_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die afwerking wat jy teëgestaan het`)
};

const hu_method_content_step_04_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A befejezés, amelynek eddig ellenálltál`)
};

/**
* | output |
* | --- |
* | "The finish you have been resisting" |
*
* @param {Method_Content_Step_04_Detail_Amateur_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_04_detail_amateur_0_heading = /** @type {((inputs?: Method_Content_Step_04_Detail_Amateur_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_04_Detail_Amateur_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "de") return de_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "th") return th_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "it") return it_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "da") return da_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "id") return id_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "el") return el_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "he") return he_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "af") return af_method_content_step_04_detail_amateur_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_04_detail_amateur_0_heading(inputs)
	return en_method_content_step_04_detail_amateur_0_heading(inputs)
});